import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import Tooltip from '../Tooltip/Tooltip';
import FormSubmit from './../FormElements/FormSubmit';
import RevenueReportingTaxesDueLaterTooltip from './RevenueReportingTaxesDueLaterTooltip';

export default function RevenueReportingSummaryCard(props) {
	// console.log('RevenueReportingSummaryCard', props);
	const [
		showMonthBreakdown,
		setShowMonthBreakdown
	] = useState(false);
	const onClickMonth = () => setShowMonthBreakdown(!showMonthBreakdown);

	const [
		showQuarterBreakdown,
		setShowQuarterBreakdown
	] = useState(false);
	const onClickQuarter = () => setShowQuarterBreakdown(!showQuarterBreakdown);

	const [
		showSemiAnnualBreakdown,
		setShowSemiAnnualBreakdown
	] = useState(false);
	const onClickSemiAnnual = () =>
		setShowSemiAnnualBreakdown(!showSemiAnnualBreakdown);

	const [
		showAnnualBreakdown,
		setShowAnnualBreakdown
	] = useState(false);
	const onClickAnnual = () => setShowAnnualBreakdown(!showAnnualBreakdown);

	return (
		<div className="PropertyBasicDetailsCard bg-white w-full min-w-96 mt-4 ma p-5 rounded-md shadow border text-gray-800 text-sm md:text-lg">
			<div className="grid grid-cols-12">
				<div className="col-span-12">
					<h2 className="text-lg lg:text-xl font-semibold mb-4">Tax Summary</h2>
				</div>
			</div>
			<div className="grid grid-cols-12 overflow-auto">
				<div className="col-span-12">
					<div>
						{showMonthBreakdown === false ? (
							<i
								className="fa fa-chevron-right mr-1.5 text-gray-400 text-sm"
								aria-hidden="true"
								onClick={onClickMonth}
							/>
						) : showMonthBreakdown === true ? (
							<i
								className="fa fa-chevron-down mr-1.5 text-gray-400 text-sm"
								aria-hidden="true"
								onClick={onClickMonth}
							/>
						) : (
							''
						)}
						<span className="inline-block">Monthly - Due now</span>
						<span className="inline-block pr-2 float-right">$1,652.14</span>
						{showMonthBreakdown && (
							<div className="bg-gray-100 p-4 mt-2 mb-4 border rounded-md">
								<div>
									<span className="inline-block ml-2">March</span>
									<span className="inline-block float-right pr-16 md:pr-24 float-right">
										$1,652.14
									</span>
								</div>
							</div>
						)}
						<div>
							<div>
								{showQuarterBreakdown === false ? (
									<i
										className="fa fa-chevron-right mr-1.5 text-gray-400 text-sm"
										aria-hidden="true"
										onClick={onClickQuarter}
									/>
								) : showQuarterBreakdown === true ? (
									<i
										className="fa fa-chevron-down mr-1.5 text-gray-400 text-sm"
										aria-hidden="true"
										onClick={onClickQuarter}
									/>
								) : (
									''
								)}
								<span className="inline-block">Quarterly - Due now</span>
								<span className="inline-block pr-2 float-right">$0.00</span>
								{showQuarterBreakdown && (
									<div className="bg-gray-100 p-4 mt-2 mb-4 border rounded-md">
										<div>
											<span className="inline-block  ml-2">January</span>
											<span className="inline-block ml-2 float-right pr-16 md:pr-24 float-right">
												$0.00
											</span>
										</div>
										<div>
											<span className="inline-block  ml-2">February</span>
											<span className="inline-block ml-2 float-right pr-16 md:pr-24 float-right">
												$0.00
											</span>
										</div>
										<div>
											<span className="inline-block  ml-2">March</span>
											<span className="inline-block ml-2 float-right pr-16 md:pr-24 float-right">
												$0.00
											</span>
										</div>
									</div>
								)}
							</div>
						</div>
						<div>
							<div>
								{showSemiAnnualBreakdown === false ? (
									<i
										className="fa fa-chevron-right mr-1.5 text-gray-400 text-sm"
										aria-hidden="true"
										onClick={onClickSemiAnnual}
									/>
								) : showSemiAnnualBreakdown === true ? (
									<i
										className="fa fa-chevron-down mr-1.5 text-gray-400 text-sm"
										aria-hidden="true"
										onClick={onClickSemiAnnual}
									/>
								) : (
									''
								)}
								<span className="inline-block">Semi-Annual - Due 6/30</span>
								<span className="inline-block pr-2 float-right">$0.00</span>
								{showSemiAnnualBreakdown && (
									<div className="bg-gray-100 p-4 mt-2 mb-4 border rounded-md">
										<div>
											<span className="inline-block ml-2">January</span>
											<span className="inline-block ml-2 float-right pr-16 md:pr-24 float-right">
												$0.00
											</span>
										</div>
										<div>
											<span className="inline-block ml-2">February</span>
											<span className="inline-block ml-2 float-right pr-16 md:pr-24 float-right">
												$0.00
											</span>
										</div>
										<div>
											<span className="inline-block ml-2">March</span>
											<span className="inline-block ml-2 float-right pr-16 md:pr-24 float-right">
												$0.00
											</span>
										</div>
										<div>
											<span className="inline-block ml-2">April</span>
											<span className="inline-block ml-2 float-right pr-16 md:pr-24 float-right">
												TBD
											</span>
										</div>
										<div>
											<span className="inline-block ml-2">May</span>
											<span className="inline-block ml-2 float-right pr-16 md:pr-24 float-right">
												TBD
											</span>
										</div>
										<div>
											<span className="inline-block ml-2">June</span>
											<span className="inline-block ml-2 float-right pr-16 md:pr-24 float-right">
												TBD
											</span>
										</div>
									</div>
								)}
							</div>
						</div>
						<div>
							<div>
								{showAnnualBreakdown === false ? (
									<i
										className="fa fa-chevron-right mr-1.5 text-gray-400 text-sm"
										aria-hidden="true"
										onClick={onClickAnnual}
									/>
								) : showAnnualBreakdown === true ? (
									<i
										className="fa fa-chevron-down mr-1.5 text-gray-400 text-sm"
										aria-hidden="true"
										onClick={onClickAnnual}
									/>
								) : (
									''
								)}
								<span className="inline-block">Annual - Due 12/31</span>
								<span className="inline-block pr-2 float-right">$520.64</span>
								{showAnnualBreakdown && (
									<div className="bg-gray-100 p-4 mt-2 mb-4 border rounded-md">
										<div>
											<span className="inline-block ml-2">January</span>
											<span className="inline-block ml-2 float-right pr-16 md:pr-24 float-right">
												$200.14
											</span>
										</div>
										<div>
											<span className="inline-block ml-2">February</span>
											<span className="inline-block ml-2 float-right pr-16 md:pr-24 float-right">
												$175.26
											</span>
										</div>
										<div>
											<span className="inline-block ml-2">March</span>
											<span className="inline-block ml-2 float-right pr-16 md:pr-24 float-right">
												$145.24
											</span>
										</div>
										<div>
											<span className="inline-block ml-2">April</span>
											<span className="inline-block ml-2 float-right pr-16 md:pr-24 float-right">
												TBD
											</span>
										</div>
										<div>
											<span className="inline-block ml-2">May</span>
											<span className="inline-block ml-2 float-right pr-16 md:pr-24 float-right">
												TBD
											</span>
										</div>
										<div>
											<span className="inline-block ml-2">June</span>
											<span className="inline-block ml-2 float-right pr-16 md:pr-24 float-right">
												TBD
											</span>
										</div>
										<div>
											<span className="inline-block ml-2">July</span>
											<span className="inline-block ml-2 float-right pr-16 md:pr-24 float-right">
												TBD
											</span>
										</div>
										<div>
											<span className="inline-block ml-2">August</span>
											<span className="inline-block ml-2 float-right pr-16 md:pr-24 float-right">
												TBD
											</span>
										</div>
										<div>
											<span className="inline-block ml-2">September</span>
											<span className="inline-block ml-2 float-right pr-16 md:pr-24 float-right">
												TBD
											</span>
										</div>
										<div>
											<span className="inline-block ml-2">October</span>
											<span className="inline-block ml-2 float-right pr-16 md:pr-24 float-right">
												TBD
											</span>
										</div>
										<div>
											<span className="inline-block ml-2">November</span>
											<span className="inline-block ml-2 float-right pr-16 md:pr-24 float-right">
												TBD
											</span>
										</div>
										<div>
											<span className="inline-block ml-2">December</span>
											<span className="inline-block ml-2 float-right pr-16 md:pr-24 float-right">
												TBD
											</span>
										</div>
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
			<hr className="my-2" />
			<div className="ml-3">
				<div className="col-span-12">
					<span className="font-semibold mb-2">Taxes Due Now</span>
					<span className="font-semibold pr-2 float-right">$1,652.14</span>
				</div>
				<div className="col-span-12 mb-6">
					<span className="mb-2">
						Taxes Due Later{' '}
						<Tooltip
							text={<RevenueReportingTaxesDueLaterTooltip />}
							placement="right"
						>
							<i className="fa fa-info-circle text-gray-700" />
						</Tooltip>
					</span>
					<span className="pr-2 float-right">$520.64</span>
				</div>
				<div className="col-span-12 mb-4">
					<span className="font-semibold block">Payment Account</span>
					<span className="inline-block">Bob's Checking</span>
					<span className="inline-block ml-2">(xxxxxx1780)</span>
				</div>
			</div>
			<div className="grid grid-cols-1">
				<div>
					<FormSubmit label="Pay $1652.14 in taxes due now" />
				</div>
			</div>
		</div>
	);
}
